import React, { useEffect } from "react";
import "../../common/fonts/fonts.css";
import "../auth/login.css";
import {Link, Navigate } from "react-router-dom";
import {useForm} from "react-hook-form";
import {loginUser} from "../../redux/actions/JWTAuth_action";
import { useSelector, useDispatch } from "react-redux";
import { general_notification } from "../../utils/notification";





function Login(){
    // const history = useNavigate();

    const login = useSelector((state)=>state.jwtAuthreducer)
    const dispatch = useDispatch();

    const {
        handleSubmit,
        register,
        formState: { errors, isSubmitting},
    }=useForm();
    // const navigate = useNavigate();

    const onSubmit = async(values)=>{

        const data = {username:values.username, password:values.password};        
        dispatch(loginUser(values.username,values.password))

    };
    useEffect(()=>{
        console.log(login,"message fo login")
    },[login])


    return(

        <div className="loginWrapper">
        <div className="leftCol">
            <div className="content">
                <img src={process.env.PUBLIC_URL +'img/bedater-logo.png' } alt="" title="" width="86" />
                <h1>Login</h1>
                <p className="mb-0">Login to your account.</p>
            </div>
            <div className="graphicImg">
                <img src={process.env.PUBLIC_URL +'img/login-debaters-img.png' } alt="asd" title="" />
            </div>
        </div>
        <div className="rightCol">
            <div className="accountTxt">
                Don’t have an Account? <Link to="/signup">Sign Up</Link>
            </div>
            <div className="form">
            {login.user && (<Navigate to="/" replace={true} />)}
                <form action="#" method="POST" onSubmit={handleSubmit(onSubmit)}>
                    <div className="form-group">
                        <label htmlFor="inputEmail">Email</label>
                        <input type="text" name="username" className="form-control" id="username"
                            aria-describedby="usernamelHelp"  {...register("username", {
                                required: "This is required field",
                              })}/>
                        <small id="emailHelp" className="form-text invalid-feedback">We'll never share your email
                            with anyone else.</small>
                    </div>
                    <div className="form-group">
                        <label htmlFor="inputPassword">Password</label>
                        <input type="password" name="password" className="form-control" id="inputPassword" {...register("password", {
                        required: "This is required field",
                        })}/>
                        <small><a style={{color:"#ffffff"}} href="#">Forgot password?</a></small>
                    </div>
                    <button className="btn btn-secondary w-100" type="submit">Login</button>
                </form>
            </div>
        </div>
        </div>
            
    );
}

export default Login;